// import React, { useState } from 'react'
// import PropTypes from 'prop-types'


// /**
//  * Componente de búsqueda reutilizable.
//  * No aplica el filtro directamente, solo notifica al componente padre cada vez que el usuario escribe algo.
//  */
// const Search = ({ placeholder = 'Buscar...', onSearchChange }) => {
//   const [searchValue, setSearchValue] = useState('')

//   const handleChange = (e) => {
//     const value = e.target.value
//     setSearchValue(value)

//     // Notifica al componente padre del nuevo valor
//     onSearchChange(value)
//   }

//   return (
//     <input
//       type='text'
//       value={searchValue}
//       onChange={handleChange}
//       placeholder={placeholder}
//       className='Search__Input' // Usa tu clase de estilos aquí
//     />
//   )
// }

// Search.propTypes = {
//   placeholder: PropTypes.string,
//   onSearchChange: PropTypes.func.isRequired,
// }



/**
 * Componente de búsqueda reutilizable.
 *
 * @param {Function} onChange - Función que recibe el texto ingresado.
 * @param {string} [value] - Texto de la caja. Si se manda, la caja es controlada: muestra siempre este
 *   texto (por ejemplo, el que se conservó al regresar a la página, o vacío al limpiar los filtros).
 *   Si no se manda, la caja se comporta como antes.
 */
const Search = ({ onChange, extraClassName, value }) => {
  return (
    <input
      id="search"
      type="text"
      placeholder="Buscar..."
      onChange={(e) => onChange(e.target.value)}
      className={`SearchInput ${extraClassName && extraClassName}`}
      {...(value !== undefined ? { value } : {})}
    />
  )
}

export { Search };